"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenCheckbox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HiddenCheckbox = _styledComponents.default.input.attrs({
  type: 'checkbox'
})(_templateObject(), (0, _polished.hideVisually)());

exports.HiddenCheckbox = HiddenCheckbox;